import React from 'react';
import PageAncestor from 'core/common/page/pageAncestor';
import mdEntityService from 'core/metamodel/mdEntityService'
import Toolmenu from 'core/components/toolmenu/toolmenu';
import {ErrorComp} from 'core/components/errorComp/errorComp';
import {EmailSentComp} from 'core/components/errorComp/alertComp';
import ConfirmationDialog from 'core/components/confirmationDialog/confirmationDialog';
import {MODULE, PERMISSION, PageProps, ID} from "core/metamodel/metaConstant";
import {observer} from "mobx-react";
import {History} from "react-router";
import {Task, EventHistory, TaskNote, HistoryObject, TASKSTATUS} from "core/event/eventDomain";
import eventService from "core/event/eventService";
import TaskForm from "core/event/component/taskForm";
import styled from "styled-components";
import {IDomainObject, lovLabel, lovValue, preSave} from "core/form/formUtils";
import {addTenantToQuery} from "core/common/utils/utils";
import {Link} from 'react-router';
import {ActivityBlock} from "core/event/component/taskActivityBlocks";
import {MdDivider} from "core/components/blockComp/blockComp";
import {addSeparator} from "core/common/utils/arrayUtils";
import {action, observable} from "mobx";
import uiService from "core/common/service/uiService";
import {CustomHistoryBlockProps, EventHistoryBlock, CustomHistoryBlock} from "core/event/component/historyBlocks";
import {WithDeleteDialogZzFlatButton, ZzFlatButton} from "core/components/buttons/buttons";
import {LoadingElement} from "core/components/common/loading";
import 'core/components/blockComp/blockComp.less';
import NoteDialog from "core/components/dialogs/noteDialog";
import AssignTaskComponent from "core/event/component/assignTaskComponent";
import {grey300, grey400} from "material-ui/styles/colors";
import {loc} from "../common/config/locales";



const TForm = styled.form`
  margin-top: 10px;
`;

const SectionDiv = styled.div`
  margin-left: 20px;
  margin-bottom: 10px;
`;


const ConnectedPersonsH5 = styled.div`
    margin-left: 20px;
    font-size: 18px;
    color: ${grey400}
`;

const TaskHistoryDiv = styled.div`
    margin-left: 20px;
    font-size: 24px;
    color: ${grey300}
`;




type TaskHistory = CustomHistoryBlockProps|EventHistory;


@observer
export default class TaskDetail extends PageAncestor<PageProps, undefined> {

  static module = MODULE.core;
  static title = 'Task';
  static icon = 'tasks';
  static protectedPage = true;


  static fetchData(routerParams, query) {
    console.log("TaskDetail#fetchData(%O)", query);


    let metadataPromise = mdEntityService.fetchEntityMetadata(['Task', 'TaskNote', 'EventHistory', 'HistoryObject', 'HistoryObjectField']);

    let taskPromise: Promise<Task>;

    if (routerParams.id === 'new') {
      taskPromise = Promise.resolve(new Task({$new: true, active: true}));
    } else {
      taskPromise = eventService.readTask(routerParams.id);
    }

    return Promise.all([metadataPromise, taskPromise])
      .then(([entityMap, taskObject]: [any, Task]) => {
        eventService.taskObject = taskObject.initAfterRead(routerParams.id === 'new');
      });
  }

  @observable private loadingHistories: boolean;
  @observable private eventHistories: EventHistory[];
  @observable private histories: TaskHistory[] = [];


  private noteDialogRef: NoteDialog;
  private closeDialogRef: NoteDialog;


  private createHistories(id: ID, reloadEventHistory: boolean) : Promise<any> {

    return Promise.resolve( (this.eventHistories && !reloadEventHistory) ? this.eventHistories : eventService.readHistory("Task", id))
      .then( (eventHistories: EventHistory[]) => {
        this.eventHistories = eventHistories;
        let histories = eventHistories.concat(eventService.taskObject.notes.map( note => ({
          icon: (note.closingNote) ? "Close" : "EventNote",
          name: (note.closingNote) ? "TASK CLOSED" : "NOTE",
          userCreated: note.userCreated,
          dateCreated: note.dateCreated,
          objectElement: <div dangerouslySetInnerHTML={{__html: note.content}}/>
        } as any) ));
        this.histories = histories.sort((a,b) => (new Date(a.dateCreated as any).getTime() - new Date(b.dateCreated as any).getTime()) );
        this.loadingHistories = false;
      } );
  }

  componentWillMount() {
    this.loadingHistories = true;
  }



  componentDidUpdate(prevProps: PageProps) {
    if (this.idChanged(prevProps.params.id, this.props.params.id)) {
      this.loadingHistories = true;
      return this.createHistories(this.props.params.id, true);
    }
  }


  componentDidMount() {
    console.debug("%c componentDidMount", "background-color: magenta");
    if (this.properId(this.props.params.id)) {
      return this.createHistories(this.props.params.id, true);
    }
  }


  @action componentWillUnmount() {
    eventService.taskObject = null;
    this.eventHistories = null;
    this.histories = null;
  }


  customValidate = (taskObject) => {
    let errors = [];

    return errors;
  };


  findRootObject() {
    return eventService.taskObject;
  }


  @action onSave = (evt) => {
    console.log('onSave ');
    uiService.showToolbarActionFlag();

    let result = preSave(eventService.taskObject, this.customValidate);
    if (!result) {
      return;
    }

    return eventService.updateTask(eventService.taskObject)
      .then(action("taskSave-callback", (taskJson: any) => {
        taskJson.objects = eventService.taskObject.objects;
        taskJson.partyActivities = eventService.taskObject.partyActivities;

        let wasNew = eventService.taskObject.cleanAfterSave(taskJson);
        if (wasNew) {
          this.context.router.replaceWith('taskDetail', {id: eventService.taskObject.taskId});
        }
        uiService.hideToolbarActionFlag();
        return this.createHistories(eventService.taskObject.taskId, true);
      }), error => {
        eventService.taskObject.$errors = error.getMessages();
      });

  };


  @action onDelete = (evt) => {
    console.log('onDelete');

    eventService.deleteTask(eventService.taskObject.taskId)
      .then(response => {
        this.goBackOrHome();
      }, error => {
        eventService.taskObject.$errors = error.getMessages();
      });
  };


  @action onAddNote = (evt) => {
    console.log('onAddNote');

    return Promise.resolve((eventService.taskObject.$new)? this.onSave(null) : null)
      .then(() => {
        return new Promise((resolve, reject) => {
          this.noteDialogRef.open(resolve, reject);
        }).then((note: string) => {
          console.log('Add note ' + note);
          uiService.showToolbarActionFlag();
          let taskNote = new TaskNote({task: eventService.taskObject.createLov(), content: note}).initAfterRead(true);
          return eventService.createTaskNote(taskNote)
            .then((taskJson: any) => {
              eventService.taskObject.cleanAfterSave(taskJson);
              uiService.hideToolbarActionFlag();
              return this.createHistories(eventService.taskObject.taskId, false);
            } );
        }).catch((e) => {
        })
      });
  };




  @action onReopen = (evt) => {
    console.log('onReopen');
    uiService.showToolbarActionFlag();
    return eventService.reopenTask(eventService.taskObject.taskId)
      .then(action("taskReopen-callback", (taskJson: any) => {
        eventService.taskObject.cleanAfterSave(taskJson);
        uiService.hideToolbarActionFlag();
        return this.createHistories(eventService.taskObject.taskId, true);
      }), error => {
        eventService.taskObject.$errors = error.getMessages();
      });
  };

  @action onClose = (evt) => {
    console.log('onClose');

    new Promise((resolve, reject) => {
      this.closeDialogRef.open(resolve, reject);
    }).then((note: string) => {
      console.log('Close ' + note);
      uiService.showToolbarActionFlag();
      let taskNote = new TaskNote({task: eventService.taskObject.createLov(), content: note}).initAfterRead(true);
      return eventService.closeTask(taskNote)
        .then((taskJson: IDomainObject) => {
          eventService.taskObject.cleanAfterSave(taskJson);
          uiService.hideToolbarActionFlag();
          return this.createHistories(eventService.taskObject.taskId, false);
        });
    }).catch((e) => {
    });
  };

  @action onAssign = (username: string): Promise<any> => {
    console.log('onAssign ' + username);
    uiService.showToolbarActionFlag();
    return eventService.assignTask(eventService.taskObject.taskId, username)
      .then(action("taskAssign-callback", (taskJson: IDomainObject) => {
        eventService.taskObject.cleanAfterSave(taskJson);
        uiService.hideToolbarActionFlag();

        //commonService.notifySuccess(null, "Task reassigned", content);
        return this.createHistories(eventService.taskObject.taskId, true);
      }), error => {
        eventService.taskObject.$errors = error.getMessages();
      });
  };


  noteDialogRefHandler = comp => this.noteDialogRef = comp;
  closeDialogRefHandler = comp => this.closeDialogRef = comp;

  render() {

    let {
      query
    } = this.props;

    let propsForCreateForm = {
      dataObject: eventService.taskObject,
      rootObject: eventService.taskObject,
      entity: mdEntityService.getEntity('Task'),
      entities: mdEntityService.entityMap
    };

    console.debug('%c taskDetail render query %O', 'background-color: yellow', this.props.query);


    return (
      <main className="main-content">
        {this._createToolMenu(eventService.taskObject, query.gridLocation)}
        <ErrorComp messages={eventService.taskObject.$errors}/>
        <EmailSentComp level="info" objekt={eventService.taskObject}/>
        <ConfirmationDialog ref={this.dirtyDialogRefHandler}/>
        <ConfirmationDialog ref={this.deleteDialogRefHandler} okButtonText={loc.i18n`Yes`} cancelButtonText={loc.i18n`No`}/>
        <NoteDialog ref={this.noteDialogRefHandler} title="Add Note"/>
        <NoteDialog ref={this.closeDialogRefHandler} title="Close Task"/>

        <div className="row zz-mt-10">
          <div className="col-xs-12 col-md-6 block-comp-right-border">
            <div className="row">
              <div className="col-xs-12">
                <TForm>
                  <TaskForm {...propsForCreateForm} />
                </TForm>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 col-sm-6">
                <ConnectedPersonsH5>Customer</ConnectedPersonsH5>
                <SectionDiv>
                  <Link to="partyDetail" params={{id: lovValue(eventService.taskObject.customer)}} query={addTenantToQuery()}>
                    {lovLabel(eventService.taskObject.customer)}
                  </Link>
                </SectionDiv>
              </div>
              <div className="col-xs-12 col-sm-6">
                <ConnectedPersonsH5>Owner</ConnectedPersonsH5>
                <SectionDiv>
                    {lovLabel(eventService.taskObject.owner)}
                </SectionDiv>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 col-sm-6">
                <ConnectedPersonsH5>Connected Persons</ConnectedPersonsH5>
                <SectionDiv>
                {eventService.taskObject.persons.map(p => (
                  <div key={p.value}>
                    <Link to="partyDetail" params={{id: lovValue(p)}} query={addTenantToQuery()}>
                      {lovLabel(p)}
                    </Link>
                  </div>
                ))}
                </SectionDiv>
              </div>

              {(eventService.taskObject.objects.length) ? (
                <div className="col-xs-12 col-sm-6">
                  <ConnectedPersonsH5>Connected Objects</ConnectedPersonsH5>
                  <SectionDiv>
                    {eventService.taskObject.objects.map(to => (
                      <div key={to.taskObjectId}>
                        <Link to={mdEntityService.getEntityDetailRoute(to.entityName)} params={{id: lovValue(to.fullObject)}} query={addTenantToQuery()}>
                          {lovLabel(to.fullObject)}
                        </Link>
                      </div>
                    ))}
                  </SectionDiv>
                </div>
              ) : null}

            </div>
            <div className="row">
              <div className="col-xs-12">
                <ConnectedPersonsH5>Activities</ConnectedPersonsH5>
                <SectionDiv>
                  {addSeparator(eventService.taskObject.partyActivities.map(pa => (
                    <div key={pa.partyActivityId}>
                      <ActivityBlock activity={pa}/>
                    </div>
                  )), <MdDivider inset/>)}
                </SectionDiv>
              </div>
            </div>
          </div>
          <div className="col-xs-12 col-sm-6">
            <TaskHistoryDiv>TASK HISTORY</TaskHistoryDiv>
            {(this.loadingHistories) ? <LoadingElement/> :
              ( (this.histories && this.histories.length) ?
                addSeparator(this.histories.map((taskHistory, index) => (
                  (taskHistory instanceof EventHistory) ? <EventHistoryBlock eventHistory={taskHistory} entities={mdEntityService.entityMap} key={index}/> : <CustomHistoryBlock {...taskHistory} key={index}/>
                )), <MdDivider inset/>) : null)
            }
          </div>
        </div>

      </main>
    );

  }


  _createToolMenu(taskObject, gridLocation) {
    return (
      <Toolmenu chainGridLocation={gridLocation} backAction={this.onBack} backDisabled={History.length <= 1}
                entityName="Task" entityId={taskObject.taskId} >

        { (lovValue(taskObject.taskStatus) !== TASKSTATUS.CLOSED) ?
          <ZzFlatButton onClick={this.onSave} disabled={!taskObject.$dirty} label="Save"
                        permission={taskObject.$new ? PERMISSION.New : PERMISSION.Update}/> : null
        }

        { (lovValue(taskObject.taskStatus) !== TASKSTATUS.CLOSED) ?
          <ZzFlatButton onClick={this.onAddNote} label="Add Note"
                        permission={taskObject.$new ? PERMISSION.New : PERMISSION.Update}/> : null
        }

        { (lovValue(taskObject.taskStatus) !== TASKSTATUS.CLOSED) ? <AssignTaskComponent taskObject={taskObject} onAssign={this.onAssign} /> : null}


        { (!taskObject.$new && lovValue(taskObject.taskStatus) === TASKSTATUS.OPEN) ?
          <ZzFlatButton onClick={this.onClose} label="Close" permission={PERMISSION.Update}/> : null}

        { (!taskObject.$new && lovValue(taskObject.taskStatus) === TASKSTATUS.CLOSED) ?
          <ZzFlatButton onClick={this.onReopen} label="Reopen" permission={PERMISSION.Update}/> : null}

        <WithDeleteDialogZzFlatButton entityName="Task" pageAncestor={this} onClick={this.onDelete} disabled={taskObject.$new} label="Delete"
                      permission={PERMISSION.Delete}/>

      </Toolmenu>
    );
  }


}






// WEBPACK FOOTER //
// ./src/core/event/taskDetail.tsx